module.exports = __webpack_public_path__ + "img/20191205171934368.ab0cd9a5.jpg";